import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchgetAllSettingsApi } from "../Redux/settings_Slice";
import FromikTextField from "../Components/Utils/Formik_Texfiled";
import CustomButton from "../Components/Utils/Custom_Btn";
import { UpdateSettingsApi } from "../Apis/settings/settings";
import {
  getHolidayDaysSimpleApi, 
  addHolidayDaySimpleApi, 
  removeHolidayDaySimpleApi 
} from "../Apis/holidays/holidaysSimple";
import UnavailableTimeSlots from "../Components/UnavailableTimeSlots/UnavailableTimeSlots";
import PackageTimeBlocks from "../Components/PackageTimeBlocks/PackageTimeBlocks";
import { useToast } from "../Hooks/useToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Chip,
  Tabs,
  Tab,
  CircularProgress
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameMonth,
  isSameDay,
  parseISO
} from "date-fns";

const CELL_SIZE = 50;

// دالة محسنة لتنسيق التاريخ بدون مشاكل فرق التوقيت
const formatDateSafe = (date) => {
  // استخدام التاريخ المحلي مباشرة بدون تحويل التوقيت
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  const formattedDate = `${year}-${month}-${day}`;
;
  
  return formattedDate;
};

// دالة للتحقق من التاريخ بالتوقيت الألماني (للمرجع فقط)
const getGermanTime = (date) => {
  const germanFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  const germanDate = germanFormatter.format(date);
  console.log(`🇩🇪 German timezone date: ${germanDate}`);
  return germanDate;
};

// دالة للتحقق من التطابق بين التواريخ
const compareDates = (date) => {
  const localDate = formatDateSafe(date);
  const germanDate = getGermanTime(date);
  
  if (localDate !== germanDate) {
    console.warn(`⚠️ Date mismatch! Local: ${localDate}, German: ${germanDate}`);
    console.warn(`⚠️ This might cause issues for German users!`);
  }
  
  return { localDate, germanDate, matches: localDate === germanDate };
};

const Einstellungen = () => {
  const role = localStorage.getItem("role");
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  const loading = useSelector((state) => state.settings.loading);
  
  // State management
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [timings, setTimings] = useState({
    summer: { open: null, close: null },
    winter: { open: null, close: null }
  });
  const [season, setSeason] = useState("summer");
  const [daysOff, setDaysOff] = useState([]);
  const [holidayPricingDays, setHolidayPricingDays] = useState([]);
  const [menDays, setMenDays] = useState(["Monday", "Wednesday", "Friday"]);
  const [womenDays, setWomenDays] = useState(["Tuesday", "Thursday", "Saturday", "Sunday"]);
  
  // Loading states
  const [isHolidayUpdating, setIsHolidayUpdating] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  
  
  const { toastSuccess, toastError } = useToast();

  const formik = useFormik({
    initialValues: {
      note1: "",
      note2: "",
      note3: ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      note1: Yup.string(),
      note2: Yup.string(),
      note3: Yup.string()
    }),
    onSubmit: async (values) => {
      console.log("🚀 Form submission started");
      
      const formatTimeWithValidation = (timeValue, label) => {
        if (!timeValue || !(timeValue instanceof Date) || isNaN(timeValue.getTime())) {
          return "";
        }
        return format(timeValue, "HH:mm");
      };

      const updatedPayload = {
        ...values,
        timings: {
          summer: {
            open: formatTimeWithValidation(timings.summer.open, "Summer Open"),
            close: formatTimeWithValidation(timings.summer.close, "Summer Close")
          },
          winter: {
            open: formatTimeWithValidation(timings.winter.open, "Winter Open"),
            close: formatTimeWithValidation(timings.winter.close, "Winter Close")
          }
        },
        daysOff,
        holidayPricingDays,
        menDays,
        womenDays
      };
      
      try {
        const result = await UpdateSettingsApi(updatedPayload);
        console.log("✅ Form submitted successfully:", result);
        dispatch(fetchgetAllSettingsApi());
        toastSuccess("Die Einstellungen wurden erfolgreich aktualisiert.");
      } catch (error) {
        console.error("❌ Form submission failed:", error);
        toastError("Fehler beim Aktualisieren der Einstellungen. Bitte versuchen Sie es erneut.");
      }      
    }
  });

  // تحميل الإعدادات الأولي
  useEffect(() => {
    const initializeSettings = async () => {
      try {
        console.log("🔄 Initializing settings...");
        await dispatch(fetchgetAllSettingsApi());
        
        // تحميل أيام العطل منفصلة
        const response = await getHolidayDaysSimpleApi();
        console.log("✅ Holiday days loaded:", response.holidayPricingDays);
        setHolidayPricingDays(response.holidayPricingDays || []);
        
        setIsInitialized(true);
      } catch (error) {
        console.error("❌ Failed to initialize settings:", error);
        setHolidayPricingDays([]);
        setIsInitialized(true);
      }
    };

    initializeSettings();
  }, [dispatch]);


  // معالجة تحديث الإعدادات من الخادم (بدون أيام العطل)
  useEffect(() => {
    if (!settings || !isInitialized) {
      return;
    }

    console.log("📋 Processing settings update...");
    
    // تحديث قيم النموذج
    formik.setValues({
      note1: settings.note1 || "",
      note2: settings.note2 || "",
      note3: settings.note3 || ""
    });

    // تحويل الأوقات
    const convertTimeStringToDate = (timeStr) => {
      if (!timeStr) return null;
      
      try {
        const [hours, minutes] = timeStr.split(":");
        if (!hours || !minutes) return null;
        
        const date = new Date();
        date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        
        return isNaN(date.getTime()) ? null : date;
      } catch (error) {
        return null;
      }
    };

    // تحديث الأوقات
    setTimings({
      summer: {
        open: convertTimeStringToDate(settings.timings?.summer?.open),
        close: convertTimeStringToDate(settings.timings?.summer?.close)
      },
      winter: {
        open: convertTimeStringToDate(settings.timings?.winter?.open),
        close: convertTimeStringToDate(settings.timings?.winter?.close)
      }
    });

    // تحديث الأيام
    if (settings.daysOff) setDaysOff(settings.daysOff);
    if (settings.menDays) setMenDays(settings.menDays);
    if (settings.womenDays) setWomenDays(settings.womenDays);

    console.log("✅ Settings updated successfully");
  }, [settings, isInitialized]);

  // دالة محسنة لتبديل أيام العطل مع إدارة أفضل للحالة
  const toggleHolidayPricingDay = useCallback(async (day) => {
    const dayFormatted = formatDateSafe(day);
    
    // التحقق من فرق التوقيت وإظهار تحذير إذا لزم الأمر
    const dateComparison = compareDates(day);
    if (!dateComparison.matches) {
      console.warn(`⚠️ Timezone difference detected for date: ${day.toDateString()}`);
      console.warn(`⚠️ Local: ${dateComparison.localDate}, German: ${dateComparison.germanDate}`);
    }
    
    console.log("🗓️ HOLIDAY - Toggling holiday pricing day:", dayFormatted);
    
    // منع التحديثات المتعددة
    if (isHolidayUpdating) {
      console.log("🚫 Already updating, ignoring click");
      return;
    }
    
    const isRemoving = holidayPricingDays.includes(dayFormatted);
    console.log("🔄 Action:", isRemoving ? "REMOVING" : "ADDING");
    
    // حفظ الحالة الحالية للإرجاع في حالة الفشل
    const previousState = [...holidayPricingDays];
    
    // تحديث فوري للواجهة (Optimistic Update)
    const optimisticUpdate = isRemoving 
      ? holidayPricingDays.filter(d => d !== dayFormatted)
      : [...holidayPricingDays, dayFormatted];
    
    setHolidayPricingDays(optimisticUpdate);
    setIsHolidayUpdating(true);
    
    try {
      let result;
      
      if (isRemoving) {
        console.log("🗑️ Removing holiday day");
        result = await removeHolidayDaySimpleApi(dayFormatted);
      } else {
        console.log("➕ Adding holiday day");
        result = await addHolidayDaySimpleApi(dayFormatted);
      }
      
      if (result.success) {
        // تأكيد التحديث بالبيانات من الخادم
        console.log("✅ Server confirmed, updating with:", result.holidayPricingDays);
        setHolidayPricingDays(result.holidayPricingDays || optimisticUpdate);
        
        // رسالة نجاح
        toastSuccess(isRemoving ? "Feiertag erfolgreich entfernt" : "Feiertag erfolgreich hinzugefügt");
      } else {
        // إرجاع التحديث في حالة الفشل
        console.log("❌ Server rejected, reverting changes");
        setHolidayPricingDays(previousState);
        throw new Error(result.error || "Server rejected the change");
      }
      
    } catch (error) {
      console.error("❌ Failed to save holiday pricing day:", error);
      
      // إرجاع التحديث في حالة الفشل
      setHolidayPricingDays(previousState);
      toastError("Fehler beim Speichern des Feiertags: " + error.message);
    } finally {
      setIsHolidayUpdating(false);
    }
  }, [holidayPricingDays, isHolidayUpdating, toastSuccess, toastError]);

  // دالة محسنة لحذف أيام العطل من القائمة
  const removeHolidayPricingDay = useCallback(async (dayToRemove) => {
    console.log("🗑️ CHIP REMOVAL - Removing holiday pricing day:", dayToRemove);
    
    // منع التحديثات المتعددة
    if (isHolidayUpdating) {
      console.log("🚫 Already updating, ignoring removal");
      return;
    }
    
    // حفظ الحالة الحالية للإرجاع في حالة الفشل
    const previousState = [...holidayPricingDays];
    
    // تحديث فوري للواجهة
    const optimisticUpdate = holidayPricingDays.filter(day => day !== dayToRemove);
    setHolidayPricingDays(optimisticUpdate);
    setIsHolidayUpdating(true);
    
    try {
      const result = await removeHolidayDaySimpleApi(dayToRemove);
      
      if (result.success) {
        console.log("✅ CHIP REMOVAL - Server confirmed");
        setHolidayPricingDays(result.holidayPricingDays || optimisticUpdate);
        toastSuccess("Feiertag erfolgreich entfernt");
      } else {
        // إرجاع التحديث في حالة الفشل
        console.log("❌ CHIP REMOVAL - Server rejected, reverting");
        setHolidayPricingDays(previousState);
        throw new Error(result.error || "Server rejected the removal");
      }
      
    } catch (error) {
      console.error("❌ CHIP REMOVAL - Failed:", error);
      
      // إرجاع التحديث في حالة الفشل
      setHolidayPricingDays(previousState);
      toastError("Fehler beim Entfernen des Feiertags: " + error.message);
    } finally {
      setIsHolidayUpdating(false);
    }
  }, [holidayPricingDays, isHolidayUpdating, toastSuccess, toastError]);

  const handleTimeChange = (seasonType, timeType, newValue) => {
    setTimings((prev) => ({
      ...prev,
      [seasonType]: { ...prev[seasonType], [timeType]: newValue }
    }));
  };

  const toggleDayOff = (day) => {
    const dayFormatted = formatDateSafe(day);
    setDaysOff((prev) =>
      prev.includes(dayFormatted)
        ? prev.filter((d) => d !== dayFormatted)
        : [...prev, dayFormatted]
    );
  };

  const removeDayOff = (dayToRemove) => {
    setDaysOff(daysOff.filter(day => day !== dayToRemove));
  };

  const nextMonth = () => setCurrentMonth(addDays(endOfMonth(currentMonth), 1));
  const prevMonth = () => setCurrentMonth(addDays(startOfMonth(currentMonth), -1));

  const handleSeasonChange = (event, newValue) => {
    setSeason(newValue);
  };

  const toggleMenDay = (day) => {
    setMenDays(prev => 
      prev.includes(day) 
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );
  };

  const toggleWomenDay = (day) => {
    setWomenDays(prev => 
      prev.includes(day) 
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );
  };

  const weekDays = [
    { en: "Monday", de: "Montag" },
    { en: "Tuesday", de: "Dienstag" },
    { en: "Wednesday", de: "Mittwoch" },
    { en: "Thursday", de: "Donnerstag" },
    { en: "Friday", de: "Freitag" },
    { en: "Saturday", de: "Samstag" },
    { en: "Sunday", de: "Sonntag" }
  ];

  const renderHeader = () => (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <IconButton onClick={prevMonth}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
      <Typography variant="body2" fontWeight={600}>
        {format(currentMonth, "MMMM yyyy")}
      </Typography>
      <IconButton onClick={nextMonth}><ArrowForwardIosIcon fontSize="small" /></IconButton>
    </Box>
  );

  const renderTimeInputs = () => {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box mt={4}>
          <Tabs value={season} onChange={handleSeasonChange} sx={{ mb: 3 }}>
            <Tab label="Sommerzeit" value="summer" />
            <Tab label="Winterzeit" value="winter" />
          </Tabs>
          
          <Grid container spacing={3}>
            <Grid item xs={5}>
              <TimePicker
                label="Öffnungszeit"
                value={timings[season].open}
                onChange={(newValue) => handleTimeChange(season, "open", newValue)}
                ampm={false}
                minutesStep={5}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !timings[season].open && timings[season].open !== null,
                    helperText: !timings[season].open && timings[season].open !== null ? "Ungültige Öffnungszeit" : "",
                  },
                }}
              />
            </Grid>
            <Grid item xs={5}>
              <TimePicker
                label="Schließzeit"
                value={timings[season].close}
                onChange={(newValue) => handleTimeChange(season, "close", newValue)}
                ampm={false}
                minutesStep={5}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !timings[season].close && timings[season].close !== null,
                    helperText: !timings[season].close && timings[season].close !== null ? "Ungültige Schließzeit" : "",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </LocalizationProvider>
    );
  };

  const renderDaysOffList = () => {
    if (daysOff.length === 0) {
      return <Typography variant="body2" color="textSecondary">Keine freien Tage festgelegt</Typography>;
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
        {daysOff.map(day => (
          <Chip
            key={day}
            label={format(parseISO(day), "dd.MM.yyyy")} 
            onDelete={() => removeDayOff(day)}
            sx={{ backgroundColor: '#f5f0e8' }}
          />
        ))}
      </Box>
    );
  };

  const renderHolidayPricingDaysList = () => {
    if (holidayPricingDays.length === 0) {
      return <Typography variant="body2" color="textSecondary">Keine Feiertage mit Sonderpreisen festgelegt</Typography>;
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
        {holidayPricingDays.map(day => (
          <Chip
            key={day}
            label={format(parseISO(day), "dd.MM.yyyy")} 
            onDelete={() => removeHolidayPricingDay(day)}
            disabled={isHolidayUpdating}
            sx={{ 
              backgroundColor: '#ffe6e6', 
              color: '#d32f2f',
              opacity: isHolidayUpdating ? 0.6 : 1
            }}
          />
        ))}
        {isHolidayUpdating && (
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
            <CircularProgress size={16} />
          </Box>
        )}
      </Box>
    );
  };

  const renderCalendar = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

    const days = [];
    let day = startDate;
    while (day <= endDate) {
      days.push(new Date(day));
      day = addDays(day, 1);
    }

    return (
      <Grid container spacing={1} justifyContent="flex-start">
        {days.map((dayItem) => {
          if (!isSameMonth(dayItem, monthStart)) return null;
          
          const formatted = format(dayItem, "d");
          const dayFormatted = formatDateSafe(dayItem);
          const isDayOff = daysOff.includes(dayFormatted);
          const isToday = isSameDay(dayItem, new Date());

          return (
            <Grid item key={dayItem.toString()}>
              <Box 
                sx={{
                  width: CELL_SIZE,
                  height: CELL_SIZE,
                  borderRadius: "50%",
                  bgcolor: isToday ? "#caa96a" : isDayOff ? "#f5f0e8" : "#ffffff",
                  border: isDayOff ? "2px solid #D6B981" : "1px solid #e0e0e0",
                  color: isDayOff ? "black" : "black",
                  fontWeight: isToday ? "bold" : "normal",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  '&:hover': {
                    backgroundColor: isToday ? "#caa96a" : isDayOff ? "#f0e6d8" : "#f5f5f5"
                  }
                }} 
                onClick={() => toggleDayOff(dayItem)}
              >
                <Typography variant="body2">{formatted}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const renderHolidayPricingCalendar = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

    const days = [];
    let day = startDate;
    while (day <= endDate) {
      days.push(new Date(day));
      day = addDays(day, 1);
    }

    return (
      <Grid container spacing={1} justifyContent="flex-start">
        {days.map((dayItem) => {
          if (!isSameMonth(dayItem, monthStart)) return null;
          
          const formatted = format(dayItem, "d");
          const dayFormatted = formatDateSafe(dayItem);
          const isHolidayPricingDay = holidayPricingDays.includes(dayFormatted);
          const isToday = isSameDay(dayItem, new Date());

          return (
            <Grid item key={dayItem.toString()}>
              <Box 
                sx={{
                  width: CELL_SIZE,
                  height: CELL_SIZE,
                  borderRadius: "50%",
                  bgcolor: isToday ? "#caa96a" : isHolidayPricingDay ? "#ffe6e6" : "#ffffff",
                  border: isHolidayPricingDay ? "2px solid #d32f2f" : "1px solid #e0e0e0",
                  color: isHolidayPricingDay ? "#d32f2f" : "black",
                  fontWeight: isToday ? "bold" : "normal",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: isHolidayUpdating ? "wait" : "pointer",
                  opacity: isHolidayUpdating ? 0.6 : 1,
                  '&:hover': {
                    backgroundColor: isToday ? "#caa96a" : isHolidayPricingDay ? "#ffd6d6" : "#f5f5f5"
                  }
                }} 
                onClick={() => !isHolidayUpdating && toggleHolidayPricingDay(dayItem)}
              >
                <Typography variant="body2">{formatted}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  if (loading || !settings) return <Typography>Loading...</Typography>;

  return (
    <Box mb={6}>
      {/* Timing Section */}
      <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
        <Box sx={{ bgcolor: "#D6B981", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
          <Typography variant="h6" color="black" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Die Tage</Typography>
        </Box>
        <Box flex={1} p={4}>
          <Typography variant="body1" color="black" fontWeight={500} mb={4} gutterBottom>Öffnungszeiten</Typography>
          
          {renderTimeInputs()}
          
          <Typography variant="body1" color="black" fontWeight={500} mt={4} gutterBottom>Freie Tage</Typography>
          {renderHeader()}
          {renderCalendar()}
          
          <Typography variant="body1" color="black" fontWeight={500} mt={4} gutterBottom>
            Ausgewählte freie Tage:
          </Typography>
          {renderDaysOffList()}
        </Box>
      </Box>

      {/* Holiday Pricing Section - disabled by request */}
      {false && (
        <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
          <Box sx={{ bgcolor: "#d32f2f", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
            <Typography variant="h6" color="white" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Feiertage</Typography>
          </Box>
          <Box flex={1} p={4}>
            <Typography variant="body1" color="black" fontWeight={500} mb={2} gutterBottom>
              Feiertage mit Sonderpreisen (priceInDayOff wird angewendet)
            </Typography>
            {renderHeader()}
            {renderHolidayPricingCalendar()}
            <Typography variant="body1" color="black" fontWeight={500} mt={4} gutterBottom>
              Ausgewählte Feiertage mit Sonderpreisen:
            </Typography>
            {renderHolidayPricingDaysList()}
          </Box>
        </Box>
      )}

      {/* Gender Days Section */}
      <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
        <Box sx={{ bgcolor: "#2196f3", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
          <Typography variant="h6" color="white" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Geschlecht</Typography>
        </Box>
        <Box flex={1} p={4}>
          <Typography variant="body1" color="black" fontWeight={500} mb={4} gutterBottom>
            Tage für Männer und Frauen festlegen
          </Typography>
          
          <Grid container spacing={4}>
            {/* Men Days */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" color="black" fontWeight={600} mb={2} sx={{ color: "#1976d2" }}>
                Männertage
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {weekDays.map(day => (
                  <Box 
                    key={`men-${day.en}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      p: 1,
                      borderRadius: 1,
                      bgcolor: menDays.includes(day.en) ? '#e3f2fd' : 'transparent',
                      border: menDays.includes(day.en) ? '2px solid #1976d2' : '1px solid #e0e0e0',
                      cursor: 'pointer',
                      '&:hover': { bgcolor: '#f5f5f5' }
                    }}
                    onClick={() => toggleMenDay(day.en)}
                  >
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        bgcolor: menDays.includes(day.en) ? '#1976d2' : 'transparent',
                        border: '2px solid #1976d2',
                        mr: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {menDays.includes(day.en) && (
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'white' }} />
                      )}
                    </Box>
                    <Typography variant="body2" color="black">
                      {day.de}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>

            {/* Women Days */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" color="black" fontWeight={600} mb={2} sx={{ color: "#e91e63" }}>
                Frauentage
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {weekDays.map(day => (
                  <Box 
                    key={`women-${day.en}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      p: 1,
                      borderRadius: 1,
                      bgcolor: womenDays.includes(day.en) ? '#fce4ec' : 'transparent',
                      border: womenDays.includes(day.en) ? '2px solid #e91e63' : '1px solid #e0e0e0',
                      cursor: 'pointer',
                      '&:hover': { bgcolor: '#f5f5f5' }
                    }}
                    onClick={() => toggleWomenDay(day.en)}
                  >
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        bgcolor: womenDays.includes(day.en) ? '#e91e63' : 'transparent',
                        border: '2px solid #e91e63',
                        mr: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {womenDays.includes(day.en) && (
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'white' }} />
                      )}
                    </Box>
                    <Typography variant="body2" color="black">
                      {day.de}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>

          <Box mt={3} p={2} sx={{ bgcolor: '#fff3e0', borderRadius: 1, border: '1px solid #ff9800' }}>
            <Typography variant="body2" color="#e65100" fontWeight={500}>
              ⚠️ Hinweis: Diese Einstellungen bestimmen, welche Tage für Männer und Frauen verfügbar sind. 
              Kunden können nur an den entsprechenden Tagen Termine buchen.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Unavailable Time Slots Section */}
      <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
        <Box sx={{ bgcolor: "#9c27b0", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
          <Typography variant="h6" color="white" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Zeiten</Typography>
        </Box>
        <Box flex={1} p={4}>
          <UnavailableTimeSlots />
        </Box>
      </Box>

      {/* Package Time Blocks Section - HIDDEN TEMPORARILY */}
      {/* <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
        <Box sx={{ bgcolor: "#455a64", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
          <Typography variant="h6" color="white" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Pakete</Typography>
        </Box>
        <Box flex={1} p={4}>
          <PackageTimeBlocks />
        </Box>
      </Box> */}

      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px" }}>
          <Box sx={{ bgcolor: "#CD9D41", width: 134, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
            <Typography color="black" variant="h6" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Notizen</Typography>
          </Box>
          <Box p={4} flex={1}>
            <Grid container spacing={5}> 
              {[1, 2, 3].map((i) => (
                <Grid size={12} key={i}>
                  <FromikTextField
                    formik={formik}
                    name={`note${i}`}
                    label={`Notiz ${i}`}
                    placeholder={`Notiz ${i}`}
                    multiline
                    maxRows={4}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        <Divider sx={{ color: "#00000038", my: 4 }} />
        <Box textAlign="right" sx={{ mt: 2, mb: 2, pr: 2 }}>
          <CustomButton
            onClick={() => formik.handleSubmit()}
            title="Einstellungen speichern"
            disabled={formik.isSubmitting}
          />
        </Box>
      </form>
    </Box>
  );
};

export default Einstellungen;
